<template>
  <div class="info-section">
    <h5>{{ title }}</h5>
    <div class="info-grid">
      <!-- Basic Info -->
      <div class="info-item">
        <span class="label">Device ID:</span>
        <span class="value">{{ airData.deviceId }}</span>
      </div>
      <div class="info-item">
        <span class="label">Serial Number:</span>
        <span class="value">{{ airData.serialNumber || 'N/A' }}</span>
      </div>

      <!-- Temperature Data -->
      <div class="info-item">
        <span class="label">Avg Temp:</span>
        <span class="value">{{ airData.avgTemp }}°F</span>
      </div>
      <div class="info-item">
        <span class="label">Start Temp:</span>
        <span class="value">{{ airData.startTemp }}°F</span>
      </div>
      <div class="info-item">
        <span class="label">End Temp:</span>
        <span class="value">{{ airData.endTemp }}°F</span>
      </div>
      <div class="info-item">
        <span class="label">Min Temp:</span>
        <span class="value">{{ airData.minTemp }}°F</span>
      </div>
      <div class="info-item">
        <span class="label">Max Temp:</span>
        <span class="value">{{ airData.maxTemp }}°F</span>
      </div>
      <div class="info-item">
        <span class="label">Std Deviation:</span>
        <span class="value">{{ airData.stdDevn }}°F</span>
      </div>

      <!-- Humidity Data -->
      <div class="info-item">
        <span class="label">Avg RH:</span>
        <span class="value">{{ airData.avgRH }}%</span>
      </div>
      <div class="info-item">
        <span class="label">Signal Count:</span>
        <span class="value">{{ airData.signalCount }}</span>
      </div>
    </div>

    <!-- Humidity Details Sub-section -->
    <div v-if="airData.humidity" class="sub-section">
      <h6>Humidity Details</h6>
      <div class="info-grid">
        <div class="info-item">
          <span class="label">Device ID:</span>
          <span class="value">{{ airData.humidity.did }}</span>
        </div>
        <div class="info-item">
          <span class="label">Min RH:</span>
          <span class="value">{{ airData.humidity.min }}%</span>
        </div>
        <div class="info-item">
          <span class="label">Max RH:</span>
          <span class="value">{{ airData.humidity.max }}%</span>
        </div>
        <div class="info-item">
          <span class="label">Avg RH:</span>
          <span class="value">{{ airData.humidity.avg }}%</span>
        </div>
        <div class="info-item">
          <span class="label">Start RH:</span>
          <span class="value">{{ airData.humidity.start }}%</span>
        </div>
        <div class="info-item">
          <span class="label">End RH:</span>
          <span class="value">{{ airData.humidity.end }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CycleAirDataSection',
  props: {
    title: {
      type: String,
      required: true
    },
    airData: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.info-section {
  margin-bottom: 24px;
  background: rgb(24, 32, 64);
  border-radius: 8px;
  padding: 20px;
  border: 1px solid rgb(58, 74, 107);

  h5 {
    margin: 0 0 16px 0;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 2px solid #4a9eff;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
      content: '🌡️';
      font-size: 14px;
    }
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;

    .info-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 20px;
      background: rgb(32, 40, 80);
      border-radius: 8px;
      border: 1px solid rgb(58, 74, 107);
      min-height: 52px;
      word-break: break-word;
      transition: all 0.2s ease;

      &:hover {
        background: rgb(42, 58, 107);
        border-color: #4a9eff;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      }

      .label {
        font-weight: 600;
        color: #ffffff;
        font-size: 13px;
        flex-shrink: 0;
        margin-right: 16px;
        min-width: 140px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .value {
        font-weight: 700;
        color: #ffffff;
        font-size: 14px;
        text-align: right;
        word-break: break-word;
        overflow-wrap: break-word;
        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      }
    }
  }

  .sub-section {
    margin-top: 20px;
    padding: 16px 20px;
    background: rgb(20, 28, 56);
    border-left: 4px solid #4a9eff;
    border-radius: 0 8px 8px 0;

    h6 {
      margin: 0 0 12px 0;
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 6px;

      &::before {
        content: '💧';
        font-size: 12px;
      }
    }
  }
}
</style>
